/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://qc0gsa8g9a.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        },
        {
            "name": "ThirdParty",
            "endpoint": "https://kotbfwvyhe.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        },
        {
            "name": "documentsapi",
            "endpoint": "https://r6zwywbz58.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        },
        {
            "name": "utilitiesapi",
            "endpoint": "https://ag1p6xde3b.execute-api.us-east-1.amazonaws.com/main",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://vdc7vnbsgrdgvjyjnvwzvbskmq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-4aehovfebjfd3nsnwamv4bs42a",
    "aws_cognito_identity_pool_id": "us-east-1:08998f36-7df9-4165-a7d3-10e67b86af94",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6o1FrhQjc",
    "aws_user_pools_web_client_id": "jqpfir4c8pqgh5klnns5nbe1a",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mhbucket81501-main",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
